import React from 'react'
import { injectIntl } from 'react-intl'

export default injectIntl(({ fields, url, intl, btnTitle = intl.formatMessage({id: 'payment_form.pay'}) }) => (
  <form action={url} method='POST'>
    {Object.keys(fields).map(key => <input type={'hidden'} key={`field-${key}`} name={key} value={fields[key]} />)}
    <button className='Button Button_white' type='submit'>{btnTitle}</button>
    <div className='Pay__meta'>
      {/* <span className='Label'>Сбербанк Онлайн, Visa, MasterCard</span> */}
    </div>
  </form>
))



// WEBPACK FOOTER //
// ./src/components/Payment/Form.jsx